import { type ExternalPaywallUrlParams } from '../../../types'
import { getBaseUrl } from '../../../utils/get-base-url'

type usePaywallUrlProps = {
  url: string
}

export const buildPaywallUrl = (params: ExternalPaywallUrlParams): string => {
  const baseUrl = getBaseUrl('billing')

  const searchParams = new URLSearchParams()

  searchParams.set('paywall', params.paywall)
  searchParams.set('plan', params.plan)
  searchParams.set('source', params.source)

  if (params.cycle) searchParams.set('cycle', params.cycle)
  if (params.task) searchParams.set('task', params.task)

  return `${baseUrl}/paywall/modal/?${searchParams.toString()}`
}

export const usePaywallUrl = (
  params: ExternalPaywallUrlParams
): usePaywallUrlProps => {
  return {
    url: buildPaywallUrl(params)
  }
}
